// customization:
// added pdc
// added ssn or libera professione
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { UniversalLink } from '@plone/volto/components';
import PuntiDiContatto from '@package/components/views/Common/PuntiDiContatto';

const messages = defineMessages({
  contacts: {
    id: 'contacts',
    defaultMessage: 'Contatti',
  },
  email_label: {
    id: 'email_label',
    defaultMessage: 'E-mail',
  },
});

const PersonaContatti = ({ content }) => {
  const intl = useIntl();

  const ssn_o_privato =
    content.esami_ssn || content.attivita_professionale_privata;

  const showSection = ssn_o_privato || content.punto_di_contatto?.length > 0;
  return showSection ? (
    <RichTextArticle
      title={intl.formatMessage(messages.contacts)}
      tag_id="contacts"
    >
      <div className="mb-3">
        <PuntiDiContatto content={content} />
      </div>

      {/* libera professione / ssn */}
      {ssn_o_privato && (
        <div className="link-ssn-libera-professione mt-2">
          {content.esami_ssn && (
            <UniversalLink
              href="/come-fare-per/prenotazioni/punti_cup"
              className="book-link btn btn-primary"
            >
              Visite ed esami SSN
            </UniversalLink>
          )}
          {content.attivita_professionale_privata && (
            <UniversalLink
              href="/come-fare-per/prenotazioni/attivita-professionale-privata-1"
              className="book-link btn btn-primary"
            >
              Libera professione
            </UniversalLink>
          )}
        </div>
      )}
    </RichTextArticle>
  ) : (
    <></>
  );
};

export default PersonaContatti;
